var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AsideContainer',[[(_vm.festival.address)?_c('FieldGoogleMap',{attrs:{"isFestivalYear":true,"clickable":true,"address":_vm.festival.address,"iframeTitle":_vm.festival.name},on:{"update:getGeoCodedPosition":function($event){return _vm.$store.dispatch('getGeoCodedPosition', $event)}}}):_vm._e(),_c('FieldOtherLinks',{attrs:{"isFestivalYear":true,"links":_vm.festival.links,"titleImage":{
        src: 'title_other_link',
        alt: '外部連結',
        mode: 'medium',
        target: 'blank',
      }}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }